var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({width: _vm.getScreenWidth > 500 ? '70%' : '100%', margin: '0 auto'})},[_c('Section1'),_vm._v(" "),_c('Section2'),_vm._v(" "),_c('Section3')],1),_vm._v(" "),_c('Section4'),_vm._v(" "),_c('Section5'),_vm._v(" "),_c('Section6'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"40px"}},[_vm._v("\n       \n    ")]),_vm._v(" "),_c('Section7')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-739a20d6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Index.vue
// module id = 56
// module chunks = 0